import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import {
    IS_AUTO_TEST_HIDE,
    IS_BIZ_USER,
    IS_CORP_USER,
    IS_MOBILE_BROWSER,
    IS_SOCIAL_USER,
    IS_WEBVIEW,
} from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { getSubscriptionsUrl } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.constants';
import { openSubscriptionsPage } from 'reactApp/utils/openHelpers';
import { getDays, getPeriodName } from 'reactApp/utils/Period';
import { bytesToGB } from 'reactApp/utils/sizeHelper';

// Фейкдор
export const abReferralProgramFakedoor: string = getFeature('ab-referral-program');

// tempexp_18086-start

export const REFERRAL_PROMO_ASIDE_PROMO_ID = 'referral-promo-aside-promo-id';

export const REFERRAL_PROMO_SPACE_PROMO_ID = 'referral-promo-space-promo-id';

export const REFERRAL_PROMO_SPACE_VISITS = 'referral-promo-space-visits';

export const REFERRAL_PROMO_BLOCK_PROMO_ID = 'referral-promo-block-promo-id';
export const REFERRAL_PROMO_BLOCK_HITS = 'referral-promo-block-hits';

/** Код который мы запомним при открытии реферального лендинга */
export const REFERRAL_BUY_CODE = 'referral-program-buy-code';

/** Код который мы получим из апи */
export const REFERRAL_STORED_API_ID = 'referral-stored-api-id';

export const REFERRAL_ANALYTIC_NAME = 'referal_friends_bonus_200gb';

const REFERRAL_PROMO_USERS = !IS_AUTO_TEST_HIDE && !IS_CORP_USER && !IS_BIZ_USER && !IS_SOCIAL_USER;
const REFERRAL_PROMO_USERS_AND_PLATFORM = !IS_MOBILE_BROWSER && !IS_WEBVIEW && REFERRAL_PROMO_USERS;

type ReferralProgramAB = 'a' | 'b' | false;

interface ReferralProgramABPromoSettings {
    asidePeriod: string;
    visitsAfterAside: number;
    blockPeriod: string;
}

const referralProgramAB: ReferralProgramAB = getFeature('referral-program-exp');
const defaultPromoSettings: ReferralProgramABPromoSettings = {
    asidePeriod: '1m',
    visitsAfterAside: 2,
    blockPeriod: '1w',
};

export const referralProgramPromoSettings: ReferralProgramABPromoSettings =
    getFeature('referral-program-exp-promo-settings') || defaultPromoSettings;

/** @description размер бонуса */
const referralProgramBonusQuotaValue = getFeature('referral-program-bonus-quota') || 200 * 1024 * 1024 * 1024;
export const referralProgramBonusQuota = bytesToGB(referralProgramBonusQuotaValue);
/** @description максимальный размер бонуса */
const referralProgramMaxQuotaValue = getFeature('referral-program-max-quota') || 2000 * 1024 * 1024 * 1024;
export const referralProgramMaxQuota = bytesToGB(referralProgramMaxQuotaValue);
/** @description период действия скидки после отключения */
const referralProgramMaxGraceDurationValue = getFeature('referral-program-grace-duration') || '21d';
export const referralProgramGraceDuration = getPeriodName(referralProgramMaxGraceDurationValue);

export function getExpiredBonusDays(expires: number, autorenewable: boolean) {
    const today = Date.now();
    const isExpired = expires && today <= expires;
    let expiredAfterDays = 0;
    if (isExpired && !autorenewable) {
        const daysWhenShowWarning = getDays(referralProgramMaxGraceDurationValue);
        const expiredDate = new Date(expires);
        const diffDays = Math.abs(differenceInCalendarDays(expiredDate, today));
        if (diffDays <= daysWhenShowWarning) {
            expiredAfterDays = diffDays;
        }
    }
    return expiredAfterDays;
}

export const referralProgramHelpLink = getFeature('referral-program-help-link') || 'https://help.mail.ru/cloud_web/';

export const goToReferralSubscriptions = () => openSubscriptionsPage({ query: 'referral=true' });
export const getReferralSubscriptionsUrl = () => getSubscriptionsUrl('referral=true');

const asidePromoWillBeShown = () => {
    const daysCount = getDays(referralProgramPromoSettings.asidePeriod);
    const passed =
        storeHelper.getValue(REFERRAL_PROMO_ASIDE_PROMO_ID) && storeHelper.isPassed(REFERRAL_PROMO_ASIDE_PROMO_ID, { daysCount });
    return passed !== false;
};

const spacePromoWillBeShown = () => {
    const visitsCount = storeHelper.getValue(REFERRAL_PROMO_SPACE_VISITS) || 0;
    return visitsCount === referralProgramPromoSettings.visitsAfterAside;
};

const blockPromoNeedToShow = () => {
    const hits = storeHelper.getValue(REFERRAL_PROMO_BLOCK_HITS) || 0;
    const daysCount = getDays(referralProgramPromoSettings.blockPeriod);
    const passed =
        storeHelper.getValue(REFERRAL_PROMO_BLOCK_PROMO_ID) && storeHelper.isPassed(REFERRAL_PROMO_BLOCK_PROMO_ID, { daysCount });
    return !hits || passed !== false;
};

export const referralProgramABEnabled = referralProgramAB === 'b';

export const referralProgramAsidePromoEnabled: boolean =
    REFERRAL_PROMO_USERS_AND_PLATFORM && referralProgramABEnabled && getFeature('referral-program-aside-promo');

export const referralProgramSpacePromoEnabled: boolean =
    !IS_WEBVIEW && REFERRAL_PROMO_USERS && referralProgramABEnabled && getFeature('referral-program-space-promo');

export const referralProgramSpaceNewEnabled: boolean = isFeature('referral-program-space-new');

export const referralProgramBlockPromoEnabled: boolean =
    REFERRAL_PROMO_USERS_AND_PLATFORM &&
    !asidePromoWillBeShown() &&
    !spacePromoWillBeShown() &&
    blockPromoNeedToShow() &&
    referralProgramABEnabled &&
    getFeature('referral-program-block-promo');

// Элементы управления на лендинге промоквоты и сабсах, а так же инфа в таблице и вопросах
export const referralProgramReferrerLanding = REFERRAL_PROMO_USERS && referralProgramABEnabled;

export const referralProgramTariffs: { month: string[]; year: string[] } = getFeature('referral-program-tariffs') || {
    month: [],
    year: [],
};

export const referralProgramModalInsteadBalloon = isFeature('referral-program-modal-instead-balloon');

registerExperiment(
    'referral-program',
    referralProgramAB,
    [
        AnalyticEventNames.REFERRAL_BALLON_SHOW,
        AnalyticEventNames.REFERRAL_BALLON_CLICK,
        AnalyticEventNames.REFERRAL_BALLON_CLOSE,
        AnalyticEventNames.REFERRAL_TOOLTIP_SHOW,
        AnalyticEventNames.REFERRAL_TOOLTIP_CLICK,
        AnalyticEventNames.REFERRAL_TOOLTIP_CLOSE,
        AnalyticEventNames.REFERRAL_BANNER_SHOW,
        AnalyticEventNames.REFERRAL_BANNER_CLICK,
        AnalyticEventNames.REFERRAL_BONUS_SPACE_CLICK,
        AnalyticEventNames.REFERRAL_SUBS_BANNER_SHOW,
        AnalyticEventNames.REFERRAL_SUBS_BANNER_CLICK,
        AnalyticEventNames.REFERRAL_BONUS_MODAL_SHOW,
        AnalyticEventNames.REFERRAL_BONUS_MODAL_CLICK,
        AnalyticEventNames.REFERRAL_BONUS_MODAL_COPY,
        AnalyticEventNames.REFERRAL_BONUS_MODAL_CLOSE,
        AnalyticEventNames.REFERRAL_BONUS_INFO_SHOW,
        AnalyticEventNames.REFERRAL_BONUS_INFO_CLOSE,
        AnalyticEventNames.QUOTA_LANDING_SHOWN,
        AnalyticEventNames.TARIFF_CLICK,
        AnalyticEventNames.REFERRAL_FAILED_MODAL_SHOW,
        AnalyticEventNames.REFERRAL_FAILED_MODAL_CLICK,
        AnalyticEventNames.REFERRAL_FAILED_MODAL_CLOSE,
    ],
    {
        mapEventNames: {
            REFERRAL_BALLON_SHOW: 'ballon-show',
            REFERRAL_BALLON_CLICK: 'ballon-click',
            REFERRAL_BALLON_CLOSE: 'ballon-close',
            REFERRAL_TOOLTIP_SHOW: 'tooltip-show',
            REFERRAL_TOOLTIP_CLICK: 'tooltip-click',
            REFERRAL_TOOLTIP_CLOSE: 'tooltip-close',
            REFERRAL_BANNER_SHOW: 'banner-show',
            REFERRAL_BANNER_CLICK: 'banner-close',
            REFERRAL_BONUS_SPACE_CLICK: 'bonus-space-click',
            REFERRAL_SUBS_BANNER_SHOW: 'subs-banner-show',
            REFERRAL_SUBS_BANNER_CLICK: 'subs-banner-click',
            REFERRAL_BONUS_MODAL_SHOW: 'bonus-modal-show',
            REFERRAL_BONUS_MODAL_CLICK: 'bonus-modal-click',
            REFERRAL_BONUS_MODAL_COPY: 'bonus-modal-copy',
            REFERRAL_BONUS_MODAL_CLOSE: 'bonus-modal-close',
            REFERRAL_BONUS_INFO_CLOSE: 'bonus-info-close',
            REFERRAL_BONUS_INFO_SHOW: 'bonus-info-show',
            REFERRAL_FAILED_MODAL_SHOW: 'failed-show',
            REFERRAL_FAILED_MODAL_CLICK: 'failed-click',
            REFERRAL_FAILED_MODAL_CLOSE: 'failed-close',
            QUOTA_LANDING_SHOWN: 'landing',
            TARIFF_CLICK: 'tariff-click',
        },
        sendXrayArgs: {
            QUOTA_LANDING_SHOWN: ({ isReferral }, { eventName }) => ({
                eventName: isReferral ? `${eventName}-referral` : eventName,
            }),
            TARIFF_CLICK: ({ isReferral }, { eventName }) => ({
                eventName: isReferral ? `${eventName}-referral` : eventName,
            }),
        },
    }
);

// tempexp_18086-end
